import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";

import theme from "theme";
import CustomRoutes from "components/CustomRoutes";
import { SnackbarMessage } from "components/SnackbarMessage";
import { Loading } from "components/Loading";
import { IdleTimeOutHandler } from "components/IdleTimeOutHandler";
import { ExternalUserSessionExpireHandler } from "components/ExternalUserSessionExpireHandler";

const App: React.FC = () => {
	return (
		<ThemeProvider theme={theme}>
			<React.Suspense fallback={<Loading />}>
				<BrowserRouter>
					<CustomRoutes />
					<IdleTimeOutHandler />
					<ExternalUserSessionExpireHandler />
				</BrowserRouter>
			</React.Suspense>
			<SnackbarMessage />
		</ThemeProvider>
	);
};

export default App;
